import {
  CONFIRM_PRODUCTION,
  GET_PRODUCT_STORE_ORDERS,
  INNER_PRODUCTION_STORE_DETAILS,
  OUTER_PRODUCTION_STORE_DETAILS
} from './ApiConstants';
import api from './ApiHandler';

export const generateOuterProductionPlan = async (payload: any) => {
  return await api.get(OUTER_PRODUCTION_STORE_DETAILS, { params: payload });
};

export const generateInnerProductionPlanHistory = async (payload: any) => {
  return await api.get(INNER_PRODUCTION_STORE_DETAILS, { params: payload });
};

export const generateProductionPlanByStore = async (payload: any) => {
  return await api.get(GET_PRODUCT_STORE_ORDERS, { params: payload });
};

export const confirmProductionProduct = async (payload: any) => {
  return await api.post(CONFIRM_PRODUCTION, payload);
};